module.exports = __webpack_public_path__ + "img/altica_high-grade.8688608c.png";